import { Form, Input, Button, message } from 'antd';
import { useLogInMutation } from '../../store/api/noLoginApi';
import { Credentials } from '../../types/types';
import style from "./Login.module.scss";
import { useForm } from "antd/lib/form/Form";
import { UserOutlined, LockOutlined } from '@ant-design/icons';
// Импортируем логотип
import logo from '../../assets/images/logo-2.svg';

function Login() {
  const [logIn, { data, isSuccess, isLoading, isError }] = useLogInMutation();
  const [form] = useForm();

  const onFinish = (values: any) => {
    let creds: Credentials = {
      username: values.username,
      password: values.password
    };
    logIn(creds);
  };

  if (isSuccess && data) {
    localStorage.setItem('token', data.token);
    window.location.href = '/';
  }

  if (isError) {
    message.error('Ошибка авторизации. Проверьте логин и пароль.');
  }

  return (
    <div className={style.loginWrapper}>
      <div className={style.loginCard}>
        <div className={style.header}>
          {/* Заменяем текстовый блок на логотип */}
          <div className={style.logoArea}>
            <img src={logo} alt="ГГНТУ Logo" className={style.logoImg} />
          </div>
          <h1>ГГНТУ</h1>
          <p>Система электронного документооборота</p>
        </div>

        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          className={style.form}
        >
          <Form.Item
            name='username'
            rules={[{ required: true, message: 'Введите ваш логин' }]}
          >
            <Input 
              prefix={<UserOutlined style={{ color: '#94a3b8' }} />} 
              placeholder="Логин" 
              size="large"
            />
          </Form.Item>

          <Form.Item
            name='password'
            rules={[{ required: true, message: 'Введите ваш пароль' }]}
          >
            <Input.Password 
              prefix={<LockOutlined style={{ color: '#94a3b8' }} />} 
              placeholder="Пароль" 
              size="large"
            />
          </Form.Item>

          <Button 
            className={style.submitBtn} 
            type="primary" 
            htmlType='submit' 
            loading={isLoading}
          >
            Войти в систему
          </Button>
        </Form>

        <div className={style.footerText}>
          © {new Date().getFullYear()} ФГБОУ ВО «ГГНТУ им. акад. М.Д. Миллионщикова»
        </div>
      </div>
    </div>
  );
}

export default Login;
